module.exports = __webpack_public_path__ + "img/color_block_1.99fd1cbc.svg";